import React from 'react';
import { Plus, Minus } from 'lucide-react';

export default function CounterControl({ value, onIncrement, onDecrement }) {
    return (
        <div className="flex items-center">
            <button
                onClick={onDecrement}
                className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center"
                type="button"
            >
                <Minus className="text-gray-500" size={20} />
            </button>
            <span className="mx-4 text-xl w-6 text-center">{value}</span>
            <button
                onClick={onIncrement}
                type="button"
                className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center"
            >
                <Plus className="text-gray-500" size={20} />
            </button>
        </div>
    );
}
